// @ts-nocheck

import { type StateType } from '../states';
import { type Selector } from '../types/selectors';
import { createResultEqualSelector } from '../utils/reselect';

import {
  selectUserBalance,
  selectUserBankrollVariation,
  selectUserFreebetBankroll,
  selectUserRealMoney,
} from './user/userPrimary.selector';

// no-memoize
const selectUserRealBalance: Selector<number | null> = (state: StateType) => {
  const realMoney = selectUserRealMoney(state);
  const balance = selectUserBalance(state);

  return realMoney ? balance || 0 : null;
};

export const selectUserBankroll = createResultEqualSelector(
  [selectUserFreebetBankroll, selectUserRealBalance, selectUserBankrollVariation],
  (bankrollFreebetValue, bankrollRealValue, bankrollVariation) => ({
    bankrollFreebetValue: bankrollFreebetValue || 0,
    bankrollRealValue,
    bankrollVariation,
  }),
);
